<script>
	export let flucs = [];

	let high = Math.max(...flucs);
	let highIndex = flucs.lastIndexOf(high);

	function calcClass(index) {
		if (index === 0) {
			return 'font-semibold text-green-500';
		} else if (index === highIndex) {
			return 'font-semibold text-red-500';
		}
		return '';
	}
</script>

<div class="flex flex-wrap">
	{#if flucs.length > 1}
		{#each flucs as fluc, i}
			<div class="{calcClass(i)} pr-2">{fluc / 100}</div>
		{/each}
	{:else}
		<div class="w-full text-center">-</div>
	{/if}
</div>
